import { render, staticRenderFns } from "./main.vue?vue&type=template&id=ab63139e&scoped=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"
import style0 from "./main.vue?vue&type=style&index=0&id=ab63139e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab63139e",
  null
  
)

export default component.exports